import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  // 状态
  state: {
    isHome: true,
    modelIndex:0,
    data:{},
    infoList:{},
    putInThePowderWeight:[],//投入粉体重量
    totalWeightOfLiquid:[],//液体总重量
    userInfo:[],
    flag:1,
    isShow:false,
  },
  // state的计算属性
  getters: {
  },
  // 更改state的状态
  mutations: {
    homeTab(state, status) {
      state.isHome = status
    },
    incrementFive(state,status){
      state.modelIndex = status
    },
    dataUpdate(state,status){
      state.data = status
    },
    infoListUpdate(state,status){
      state.infoList = status
    },
    putInThePowderWeightUpdate(state,status){//投入粉体重量
      state.putInThePowderWeight = status;
    },
    totalWeightOfLiquidUpdate(state,status){
      state.totalWeightOfLiquid = status;//液体总重量
    },
    userInfo(state,status){
      state.userInfo = status;
    },
    flagUpdate(state,status){
      state.flag = status;
    },
    isShowUpdate(state,status){
      state.isShow = status;
    },
    getImgUrl(state,status){
      state.imgUrl = status;
    }
  },
  // 提交mutations,异步操作
  actions: {
  },
  // 模块化
  modules: {
  }
})
